module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n            ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Custom Clearance Import Form")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-button-group', {
    attrs: {
      "size": "sm"
    }
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.CC_EDI == '0' ? true : false,
      "variant": _vm.CC_EDI == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('EDI')
      }
    }
  }, [_vm._v("EDI Execution")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.CC_EXEC == '0' ? true : false,
      "variant": _vm.CC_EXEC == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('EXEC')
      }
    }
  }, [_vm._v("Execution")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "disabled": _vm.CC_TRACK == '0' ? true : false,
      "variant": _vm.CC_TRACK == '0' ? '' : 'success'
    },
    on: {
      "click": function($event) {
        _vm.gotToPage('TRACK')
      }
    }
  }, [_vm._v("Tracking")])], 1)], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Importer Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Importer Name"
    },
    model: {
      value: (_vm.ccModal.importerClientId),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "importerClientId", $$v)
      },
      expression: "ccModal.importerClientId"
    }
  }), _vm._v(" "), (!_vm.ccModal.importerClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.importerClientId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Exporter Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.clientList,
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Exporter Name"
    },
    model: {
      value: (_vm.ccModal.exporterClientId),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "exporterClientId", $$v)
      },
      expression: "ccModal.exporterClientId"
    }
  }), _vm._v(" "), (!_vm.ccModal.exporterClientId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.exporterClientId))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.openExpoInput == true) ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Exporter Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherExpoName",
      "name": "otherExpoName"
    },
    model: {
      value: (_vm.ccModal.otherExpoName),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "otherExpoName", $$v)
      },
      expression: "ccModal.otherExpoName"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "PORlocationId"
    }
  }, [_vm._v("Place of Receipt")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": "",
      "list": _vm.IcdPOrtListNew,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'IcdPOrtList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'IcdPOrtList')
      }
    },
    model: {
      value: (_vm.ccModal.PORlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "PORlocationId", $$v)
      },
      expression: "ccModal.PORlocationId"
    }
  }), _vm._v(" "), (!_vm.ccModal.PORlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.PORlocationId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "LPlocationId"
    }
  }, [_vm._v("Load Port Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PortLoadList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port Name",
      "isDisabled": ""
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port,Air_Port', 'PortLoadList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port,Air_Port', 'PortLoadList')
      }
    },
    model: {
      value: (_vm.ccModal.LPlocationId),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "LPlocationId", $$v)
      },
      expression: "ccModal.LPlocationId"
    }
  }), _vm._v(" "), (!_vm.ccModal.LPlocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.LPlocationId))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "PODLocationId"
    }
  }, [_vm._v("Port of Discharge")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getPortDischargeList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge",
      "isDisabled": ""
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'Sea_Port,Air_Port', 'getPortDischargeList')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'Sea_Port,Air_Port', 'getPortDischargeList')
      }
    },
    model: {
      value: (_vm.ccModal.PODLocationId),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "PODLocationId", $$v)
      },
      expression: "ccModal.PODLocationId"
    }
  }), _vm._v(" "), (!_vm.ccModal.PODLocationId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.PODLocationId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('label', {
    attrs: {
      "for": "PODLocationId"
    }
  }, [_vm._v("Final Place of Delivery")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceData,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Final Place Delivery",
      "isDisabled": ""
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceData')
      }
    },
    model: {
      value: (_vm.ccModal.fpodName),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "fpodName", $$v)
      },
      expression: "ccModal.fpodName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Pre-Alert Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "preAlertDate",
      "name": "preAlertDate"
    },
    model: {
      value: (_vm.ccModal.preAlertDate),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "preAlertDate", $$v)
      },
      expression: "ccModal.preAlertDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Vessel ETA")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "vesselEta",
      "name": "vesselEta"
    },
    model: {
      value: (_vm.ccModal.vesselEta),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "vesselEta", $$v)
      },
      expression: "ccModal.vesselEta"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("\n                    Free Days at India\n                    Port\n                  ")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "freeDaysIndia",
      "name": "freeDaysIndia"
    },
    model: {
      value: (_vm.ccModal.freeDaysIndia),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "freeDaysIndia", $$v)
      },
      expression: "ccModal.freeDaysIndia"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "pdaDetail"
    }
  }, [_vm._v("Destination Handling Fees By")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.pdaDetailsName,
      "option-value": "pdaDetailsVal",
      "option-text": "pdaDetailsText",
      "placeholder": "Select "
    },
    model: {
      value: (_vm.ccModal.pdaDetail),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "pdaDetail", $$v)
      },
      expression: "ccModal.pdaDetail"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', [_vm._v("MBL No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mblNo",
      "name": "mblNo"
    },
    model: {
      value: (_vm.ccModal.mblNo),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "mblNo", $$v)
      },
      expression: "ccModal.mblNo"
    }
  }), _vm._v(" "), (!_vm.ccModal.mblNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.mblNo))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("MBL Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "mblDate",
      "name": "mblDate"
    },
    model: {
      value: (_vm.ccModal.mblDate),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "mblDate", $$v)
      },
      expression: "ccModal.mblDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    attrs: {
      "for": "stuffingType"
    }
  }, [_vm._v("De-Stuffing Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.stuffingTypeName,
      "option-value": "stuffingTypeVal",
      "option-text": "stuffingTypeText",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.ccModal.stuffingType),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "stuffingType", $$v)
      },
      expression: "ccModal.stuffingType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('b-badge', [_vm._v("HBL Details")])], 1)]), _vm._v(" "), _c('b-card', {
    attrs: {
      "clstyle": "background:whiteSmoke"
    }
  }, [_c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', [_vm._v("HBL No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mblNo",
      "name": "mblNo"
    },
    model: {
      value: (_vm.ccModal.hblNo),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "hblNo", $$v)
      },
      expression: "ccModal.hblNo"
    }
  }), _vm._v(" "), (!_vm.ccModal.hblNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.hblNo))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("HBL Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "hblDate",
      "name": "hblDate"
    },
    model: {
      value: (_vm.ccModal.hblDate),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "hblDate", $$v)
      },
      expression: "ccModal.hblDate"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.ccModal.multiHBL), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "40"
      }
    }, [_c('label', {
      attrs: {
        "for": "stuffingType"
      }
    }, [_vm._v("HBL No.")]), _vm._v(" "), _c('b-input', {
      staticStyle: {
        "height": "37px"
      },
      attrs: {
        "name": "securityAmount",
        "id": "securityAmount"
      },
      model: {
        value: (item.multiHBLNo),
        callback: function($$v) {
          _vm.$set(item, "multiHBLNo", $$v)
        },
        expression: "item.multiHBLNo"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('label', [_vm._v("HBL Date")]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "lang": "en",
        "format": _vm.selectDateFormat,
        "id": "receivedDo",
        "name": "receivedDo"
      },
      model: {
        value: (item.multiHBLDate),
        callback: function($$v) {
          _vm.$set(item, "multiHBLDate", $$v)
        },
        expression: "item.multiHBLDate"
      }
    })], 1), _vm._v(" "), _c('b-button', {
      staticClass: "ml-2",
      staticStyle: {
        "margin-top": "38px"
      },
      attrs: {
        "size": "sm",
        "variant": "outline-dark"
      },
      on: {
        "click": function($event) {
          _vm.removeHBL(index)
        }
      }
    }, [_c('md-icon', [_vm._v("remove")])], 1)], 1)], 1)
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('b-button', {
    staticClass: "md-fab md-fab",
    attrs: {
      "variant": "outline-dark",
      "size": "sm"
    },
    on: {
      "click": _vm.addAdditionalHBL
    }
  }, [_vm._v("Add More HBL")])], 1)], 1)], 2), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "shippingId"
    }
  }, [_vm._v("Shipping Line Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.shippingList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ccModal.shippingId),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "shippingId", $$v)
      },
      expression: "ccModal.shippingId"
    }
  }), _vm._v(" "), (!_vm.ccModal.shippingId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorHouseBL.shippingId))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Gateway IGM No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "igmNo",
      "name": "igmNo"
    },
    model: {
      value: (_vm.ccModal.gateIgmNo),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "gateIgmNo", $$v)
      },
      expression: "ccModal.gateIgmNo"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("Gateway IGM Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "format": _vm.selectDateFormat,
      "id": "receivingDate",
      "name": "receivingDate"
    },
    model: {
      value: (_vm.ccModal.gatewayIgmDate),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "gatewayIgmDate", $$v)
      },
      expression: "ccModal.gatewayIgmDate"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Vessel / Voy")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vesselName",
      "name": "vesselName"
    },
    model: {
      value: (_vm.ccModal.vesselName),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "vesselName", $$v)
      },
      expression: "ccModal.vesselName"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Vessel Arrival Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "format": _vm.selectDateFormat,
      "id": "vesselFinalDate",
      "name": "vesselFinalDate"
    },
    model: {
      value: (_vm.ccModal.vesselFinalDate),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "vesselFinalDate", $$v)
      },
      expression: "ccModal.vesselFinalDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ccModal.PODLocationId != _vm.ccModal.fpodName) ? _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', [_vm._v("Local IGM No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "igmNo",
      "name": "igmNo"
    },
    model: {
      value: (_vm.ccModal.igmNo),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "igmNo", $$v)
      },
      expression: "ccModal.igmNo"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.ccModal.PODLocationId != _vm.ccModal.fpodName) ? _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Local Igm Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "format": _vm.selectDateFormat,
      "id": "vesselFinalDate",
      "name": "vesselFinalDate"
    },
    model: {
      value: (_vm.ccModal.igmDate),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "igmDate", $$v)
      },
      expression: "ccModal.igmDate"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('b-badge', [_vm._v("Container Details")])], 1)]), _vm._v(" "), _c('b-card', {
    staticClass: "mt-3",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [(_vm.multiContainer.length > 1 && _vm.multiContainer[0].freeDays != '' && _vm.multiContainer[0].railOutDate != '' && _vm.multiContainer[0].arrivalDate != '') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "80"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "checkbox-1",
      "name": "checkbox-1",
      "value": "1",
      "unchecked-value": "0"
    },
    on: {
      "change": _vm.addSameDateRadio
    },
    model: {
      value: (_vm.allSame),
      callback: function($$v) {
        _vm.allSame = $$v
      },
      expression: "allSame"
    }
  }, [_vm._v("Port ETA Date,CFS Arrival Date,Free Days Upto is Same")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.multiContainer), function(item, index) {
    return _c('md-layout', {
      key: index,
      staticClass: "gutr",
      attrs: {
        "gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "20"
      }
    }, [_c('label', [_vm._v("Container No.")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "maxlength": "11"
      },
      on: {
        "keyup": function($event) {
          _vm.containerNoRegexfun(index)
        }
      },
      model: {
        value: (_vm.multiContainer[index].ContainerNo),
        callback: function($$v) {
          _vm.$set(_vm.multiContainer[index], "ContainerNo", $$v)
        },
        expression: "multiContainer[index].ContainerNo"
      }
    }), _vm._v(" "), (_vm.multiContainer[index].ContainerNo != '') ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(_vm.containerNoRegexError[index]))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "20"
      }
    }, [_c('label', {
      attrs: {
        "for": "containerTypeId"
      }
    }, [_vm._v("Container Type/Size")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "isDisabled": "",
        "list": _vm.ContainerTypeList,
        "option-value": "containerTypeId",
        "option-text": "containerType",
        "placeholder": "Select  Type"
      },
      model: {
        value: (_vm.multiContainer[index].ContainerType),
        callback: function($$v) {
          _vm.$set(_vm.multiContainer[index], "ContainerType", $$v)
        },
        expression: "multiContainer[index].ContainerType"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [(_vm.ccModal.PODLocationId != _vm.ccModal.fpodName) ? _c('label', [_vm._v("Rail Out Date")]) : _c('label', [_vm._v("Port ETA Date")]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "lang": "en",
        "format": _vm.selectDateFormat,
        "id": "railOutDate",
        "name": "railOutDate"
      },
      on: {
        "change": function($event) {
          _vm.addSameDate(index)
        }
      },
      model: {
        value: (_vm.multiContainer[index].railOutDate),
        callback: function($$v) {
          _vm.$set(_vm.multiContainer[index], "railOutDate", $$v)
        },
        expression: "multiContainer[index].railOutDate"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [(_vm.ccModal.PODLocationId != _vm.ccModal.fpodName) ? _c('label', [_vm._v("ICD Arrival Date")]) : _c('label', [_vm._v("CFS Arrival Date")]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "lang": "en",
        "format": _vm.selectDateFormat,
        "id": "arrivalDate",
        "name": "arrivalDate"
      },
      on: {
        "change": function($event) {
          _vm.addSameDate(index)
        }
      },
      model: {
        value: (_vm.multiContainer[index].arrivalDate),
        callback: function($$v) {
          _vm.$set(_vm.multiContainer[index], "arrivalDate", $$v)
        },
        expression: "multiContainer[index].arrivalDate"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('label', [_vm._v("Free Days Upto")]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "lang": "en",
        "format": _vm.selectDateFormat,
        "id": "freeDays",
        "name": "freeDays"
      },
      on: {
        "change": function($event) {
          _vm.addSameDate(index)
        }
      },
      model: {
        value: (_vm.multiContainer[index].freeDays),
        callback: function($$v) {
          _vm.$set(_vm.multiContainer[index], "freeDays", $$v)
        },
        expression: "multiContainer[index].freeDays"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }, [_c('b-button', {
      staticClass: "ml-2",
      staticStyle: {
        "margin-top": "38px"
      },
      attrs: {
        "size": "sm",
        "variant": "outline-dark"
      },
      on: {
        "click": function($event) {
          _vm.removeNotify(index)
        }
      }
    }, [_c('md-icon', [_vm._v("remove")])], 1)], 1)], 1)
  })], 2), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('h5', [_c('b-badge', [_vm._v("Check with Importer For")])], 1)])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.showSegmentArray), function(segmentNameArray, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": segmentNameArray.value,
        "name": 'checkWithImporter' + (index + 1),
        "id": 'checkWithImporter' + (index + 1)
      },
      model: {
        value: (_vm.ccModal.checkWithImporter[index]),
        callback: function($$v) {
          _vm.$set(_vm.ccModal.checkWithImporter, index, $$v)
        },
        expression: "ccModal.checkWithImporter[index]"
      }
    }, [_vm._v(_vm._s(segmentNameArray.show))])], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), (_vm.ccModal.checkWithImporter[index] == true) ? _c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-flex": "80"
      }
    }, [_c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll
      },
      model: {
        value: (_vm.ccModal.rebateAll[index]),
        callback: function($$v) {
          _vm.$set(_vm.ccModal.rebateAll, index, $$v)
        },
        expression: "ccModal.rebateAll[index]"
      }
    }, [_vm._v(_vm._s(segmentNameArray.show))])], 1) : _vm._e()], 1)
  })), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "autoCommodity"
    }
  }, [_vm._v("Commodity")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.getCommodityData,
      "option-value": "commodityId",
      "option-text": "itemDescription",
      "placeholder": "Select Commodity"
    },
    on: {
      "searchchange": function($event) {
        _vm.getCommodityList($event, 'getCommodityData')
      }
    },
    model: {
      value: (_vm.ccModal.commodityId),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "commodityId", $$v)
      },
      expression: "ccModal.commodityId"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('label', {
    attrs: {
      "for": "commodityType"
    }
  }, [_vm._v("Commodity Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.commodityTypeName,
      "option-value": "commodityTypeVal",
      "option-text": "commodityTypeText",
      "placeholder": "Select Commodity Type"
    },
    model: {
      value: (_vm.ccModal.commodityType),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "commodityType", $$v)
      },
      expression: "ccModal.commodityType"
    }
  })], 1)], 1), _vm._v(" "), (_vm.ccModal.commodityType == 'Hazardous') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("IMDG Class")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "IMDGClass",
      "name": "IMDGClass"
    },
    model: {
      value: (_vm.ccModal.IMDGClass),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "IMDGClass", $$v)
      },
      expression: "ccModal.IMDGClass"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("UN Number")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "UNNumber",
      "name": "UNNumber"
    },
    model: {
      value: (_vm.ccModal.UNNumber),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "UNNumber", $$v)
      },
      expression: "ccModal.UNNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Packing Code")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "packingCode",
      "name": "packingCode"
    },
    model: {
      value: (_vm.ccModal.packingCode),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "packingCode", $$v)
      },
      expression: "ccModal.packingCode"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ccModal.commodityType == 'Reefer') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Temperature Req(Degree Celsius)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "temperatureRequired",
      "name": "temperatureRequired"
    },
    model: {
      value: (_vm.ccModal.temperatureRequired),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "temperatureRequired", $$v)
      },
      expression: "ccModal.temperatureRequired"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.ccModal.commodityType == 'Others') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Specific Detail if any..!")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "otherComodity",
      "name": "otherComodity"
    },
    model: {
      value: (_vm.ccModal.otherComodity),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "otherComodity", $$v)
      },
      expression: "ccModal.otherComodity"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "itemDescription"
    }
  }, [_vm._v("Remark")]), _vm._v(" "), _c('b-form-textarea', {
    staticStyle: {
      "height": "140px"
    },
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.ccModal.remark),
      callback: function($$v) {
        _vm.$set(_vm.ccModal, "remark", $$v)
      },
      expression: "ccModal.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('h5', [_c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload  Documents")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderPro"
    },
    on: {
      "click": function($event) {
        _vm.addCCImport('0')
      }
    }
  }, [_vm._v("Save & Submit")])], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderPro"
    },
    on: {
      "click": function($event) {
        _vm.addCCImport('csfds')
      }
    }
  }, [_vm._v("Save & Proceed to Edi Execution")])], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), (_vm.ALLMODULE) ? _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertAddSeaImp",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseEdiTeam
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop7",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose7
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "message",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54a54006","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/CCImport/CCImportEntry.vue
// module id = 2637
// module chunks = 0